module.exports = __webpack_public_path__ + "static/img/IMG_2158.3113b21.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/talalok/IMG_2158.jpg
// module id = 616
// module chunks = 0